import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import ProductPageNew from './ProductPageNew';
import ProductPageSolutionCopy from './ProductPageSolutionCopy';

const ProductPageRoute = () => {
  const { id, solutionSlug } = useParams();
  const [searchParams] = useSearchParams();
  const template = searchParams.get('template');
  const productKey = id || solutionSlug;

  if (template === 'solution') {
    return <ProductPageSolutionCopy key={productKey} />;
  }

  return <ProductPageNew key={productKey} />;
};

export default ProductPageRoute;
